import { createAction } from '@reduxjs/toolkit'
import { IdUsersStateDataItem, typeUsersFilters } from 'model/dashboardUsers/dUsersReducer'
import { typePagination, typeRequestPagination } from 'model/system/constants';


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set data
export const dUsersSetDataAC = createAction(
    'D_USERS_SET_DATA',
    (dataList: IdUsersStateDataItem[]) => ( { payload: { dataList } } )
)

// Action creator of saga set data
export const dUsersSetDataSagaAC = createAction(
    'D_USERS_SET_DATA_SAGA',
    (
        filters: typeUsersFilters,
        paginationRequest: typeRequestPagination
    ) => ( { payload: { filters, paginationRequest } } )
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set data detail
export const dUsersSetDetailItemAC = createAction(
    'D_USERS_SET_DETAIL_ITEM',
    (detailItemId: string) => ( { payload: detailItemId } )
)

// ---------------------------------------------------------------------------------------------------------------------

// Action creator of saga add item
export const dUsersAddItemSagaAC = createAction(
    'D_USERS_ADD_SAGA_ITEM',
    (
        itemObject: {
            firstName: string,
            lastName: string,
            position: string | null,
            email: string,
            phoneNumber: string | null,
            storeId: string | null,
            pin: string,
            password: string
        },
        filters: typeUsersFilters,
        paginationRequest: typeRequestPagination
    ) => ( { payload: { itemObject, filters, paginationRequest } } )
)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of edit data
export const dUsersEditItemAC = createAction(
    'D_USERS_EDIT_ITEM',
    (detailItemObject: IdUsersStateDataItem) => ( { payload: detailItemObject } )
)

// Action creator of saga edit data
export const dUsersEditItemSagaAC = createAction(
    'D_USERS_EDIT_SAGA_ITEM',
    (
        detailItemObject: IdUsersStateDataItem,
        filters: typeUsersFilters,
        paginationRequest: typeRequestPagination) => ( { payload: { detailItemObject, filters, paginationRequest } } ),
)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of clear filtersForm
export const dUsersClearFiltersAC = createAction(
    'D_USERS_CLEAR_FILTERS',
)

// Action creator of set filtersForm
export const dUsersSetFiltersAC = createAction(
    'D_Users_SET_FILTERS',
    (filterObj: typeUsersFilters) => ( { payload: filterObj } )
)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of delete item
export const dUsersDeleteItemAC = createAction(
    'D_USERS_DELETE_ITEM',
    (itemId: string) => ( { payload: itemId, } )
)

// Action creator of saga delete item
export const dUsersDeleteItemSagaAC = createAction(
    'D_USERS_DELETE_SAGA_ITEM',
    (
        itemId: string,
        filters: typeUsersFilters,
        paginationRequest: typeRequestPagination) => ( { payload: { itemId, filters, paginationRequest } } )
)
// ---------------------------------------------------------------------------------------------------------------------
// Action creator of saga bulk recover
export const dUsersRecoverBulkSagaAC = createAction(
    'D_USERS_RECOVER_BULK_SAGA',
    (
        bulkIds: string[],
        filters: typeUsersFilters,
        paginationRequest: typeRequestPagination) => ( { payload: { bulkIds, filters, paginationRequest } } )
)

// Action creator of saga change password data
export const dUsersChangePasswordItemSagaAC = createAction(
    'D_USERS_CHANGE_PASSWORD_SAGA_ITEM',
    (
        newPassword: string,
        emailUser: string,
    ) => ( { payload: { newPassword, emailUser } } )
)

// Action creator of saga change PIN data
export const dUsersChangePINItemSagaAC = createAction(
    'D_USERS_CHANGE_PIN_SAGA_ITEM',
    (
        data: {
            id: string,
            pin: string
        }
    ) => ( { payload: { data } } )
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set pagination
export const dUsersSetPaginationAC = createAction(
    'D_USERS_SET_PAGINATION',
    (
        pagination: typePagination,
    ) => ( { payload: { pagination } } )
)

// Action creator of set itemsForPage in pagination
export const dUsersSetItemsForPageAC = createAction(
    'D_USERS_SET_ITEMS_FOR_PAGE',
    (
        itemsForPage: number,
    ) => ( { payload: { itemsForPage } } )
)


// Action creator of set pageNumber in pagination
export const dUsersSetPageNumberAC = createAction(
    'D_USERS_SET_PAGE_NUMBER',
    (
        pageNumber: number,
    ) => ( { payload: { pageNumber } } )
)
